import React, { FC } from 'react';
import PropTypes from 'prop-types';
import logo from '../assets/logo.png'

interface ILogoProps {
	width?: number;
	height?: number;
}
const Logo: FC<ILogoProps> = ({ width, height }) => {
	return (
		 <div>
            <img src={logo }alt=""  width={width} />
         </div>
	);
};
// @ts-ignore
// @ts-ignore
Logo.propTypes = {
	// @ts-ignore
	width: PropTypes.number,
	height: PropTypes.number,
};
Logo.defaultProps = {
	width: 2155,
	height: 854,
};

export default Logo;
